/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { SystemConfigGet } from './system-config.get';

export const SystemConfigPatch = {
  id: 'system-config.patch',
  tag: 'Common',
  summary: 'Patch system config',
  description: 'Update the system config',
  method: 'patch',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/system-config`,
  request: {
    body: {
      required: true,
      content: {
        'application/json': {
          schema: z.strictObject({
            smtpHost: ZodTypes.TrimmedString.min(1).nullish(),
            smtpPort: z.number().positive().int('invalid_integer').nullish(),
            smtpSecure: z.boolean().nullish(),
            smtpUser: ZodTypes.TrimmedString.min(1).nullish(),
            smtpPass: ZodTypes.TrimmedString.min(1).nullish(),
            smtpFromEmail: z.string().nullish(),
            enquiryEmails: z.string().optional(),
            enquiryEmailLanguage: ZodTypes.Language.optional(),
            allowServiceCreation: z.boolean().optional(),
            showInstanceCost: z.boolean().optional(),
            showSupportCost: z.boolean().optional(),
            minCpuLimit: z.number().nullish(),
            maxCpuLimit: z.number().nullish(),
            minMemoryLimit: z.number().nullish(),
            maxMemoryLimit: z.number().nullish(),
            minStorageLimit: z.number().nullish(),
            maxStorageLimit: z.number().nullish(),
            minReplicasLimit: z.number().optional(),
            maxReplicasLimit: z.number().max(10).optional(),
            currency: z.string().min(3).max(3).nullish(),
            cpuPricePerMonth: z.number().nullish(),
            memoryPricePerMonth: z.number().nullish(),
            storagePricePerMonth: z.number().nullish(),
            cpuRequestToLimitMultiplier: z.number().min(1).nullish(),
            resourceUsageCpuThreshold: z.number().min(0).max(1).nullish(),
            resourceUsageMemoryThreshold: z.number().min(0).max(1).nullish(),
            active: z.boolean().optional(),
            emailAddress: z.string().nullish(),
            emailToken: z.string().nullish(),
            imprint: z.string().optional(),
          }),
        },
      },
    },
  },
  response: SystemConfigGet.response,
} as const satisfies Endpoint;
